import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { PublicLayout } from '../components/Layout';

export function AccessDenied() {
  const [params] = useSearchParams();
  const auth = useAuth();
  const reason = params.get('reason');

  return (
    <PublicLayout>
      <div className="flex flex-1 flex-col items-center justify-center px-6 py-20 text-center">
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-danger/10 text-danger" aria-hidden>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <path d="m4.9 4.9 14.2 14.2" />
          </svg>
        </div>
        <h1 className="mt-5 text-2xl font-bold">Sign-in didn't work</h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-muted">
          The Forms Hub admin area is restricted to <strong className="text-foreground">knocking.com Google
          Workspace accounts</strong>. If you signed in with a personal Google account, try again with your
          knocking.com one.
        </p>
        {reason && (
          <p className="mt-4 max-w-md rounded-xl border border-border bg-card px-4 py-2.5 font-mono text-xs text-muted">
            {reason}
          </p>
        )}
        <div className="mt-8 flex items-center gap-4">
          <button
            type="button"
            onClick={() => void auth.signinRedirect()}
            className="rounded-full bg-brand px-5 py-2.5 text-sm font-semibold text-brand-contrast transition-colors hover:bg-brand-strong"
          >
            Try again
          </button>
          <Link to="/" className="text-sm font-medium text-muted underline underline-offset-2 transition-colors hover:text-foreground">
            Back home
          </Link>
        </div>
      </div>
    </PublicLayout>
  );
}
